(function () {
  var READY_LABEL = "Add to cart — Start my portrait";
  var NEED_LABEL = "Upload a photo to continue";

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function uploadRoot() {
    return qs(".ymq_upload_box") || qs(".ymq_upload") || qs(".ymq_upload_new");
  }
  function pageHasYmq() {
    return !!(uploadRoot() || qs(".ymq_option") || qs("[class*='ymq_upload']") || (window.ymq_option && window.ymq_option.page === "product"));
  }
  function hasUpload() {
    // Strict: YMQ success class or preview items inside upload box only
    if (qs(".ymq_upload_success")) return true;
    if (qs(".ymq_upload_box .ymq_upload_img_item, .ymq_upload .ymq_upload_img_item, .ymq_upload_img_item_bg")) return true;
    if (qs(".ymq_upload_box .ymq_upload_img_view img, .ymq_upload .ymq_upload_img_view img")) return true;
    var inputs = qsa(".ymq_upload input[type='file'], .ymq_upload_box input[type='file'], input[type='file']");
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].files && inputs[i].files.length) return true;
    }
    return false;
  }
  function atcButtons() {
    return qsa(
      "product-form-component button[type='submit'], product-form-component button[name='add'], form[data-type='add-to-cart-form'] button[type='submit'], form[data-type='add-to-cart-form'] button[name='add'], button.add-to-cart-button, .buy-buttons-block button[type='submit'], .buy-buttons-block button[name='add']"
    ).filter(function (b, i, arr) { return b && arr.indexOf(b) === i; });
  }
  function setButtonLabel(btn, text) {
    btn.setAttribute("data-cfp-needs-upload", text === NEED_LABEL ? "1" : "0");
    if (text === NEED_LABEL) btn.setAttribute("aria-disabled", "true");
    else btn.removeAttribute("aria-disabled");
    btn.setAttribute("aria-label", text);
    var replaced = false;
    var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (/add to cart|upload a photo|start my portrait|sold out|unavailable/i.test(node.textContent)) {
        node.textContent = text;
        replaced = true;
        break;
      }
    }
    if (!replaced) {
      var span = qs("span:not(.svg-wrapper):not(.icon)", btn);
      if (span && !span.querySelector("svg")) span.textContent = text;
    }
  }
  function sync() {
    if (!pageHasYmq()) return;
    var needs = !hasUpload();
    atcButtons().forEach(function (btn) { setButtonLabel(btn, needs ? NEED_LABEL : READY_LABEL); });
    var coach = qs("[data-cfp-upload-coach]");
    var warn = qs("[data-cfp-upload-warn]");
    if (!needs) {
      if (warn) warn.classList.add("hidden");
      if (coach) coach.classList.remove("is-highlight");
    }
  }
  function highlight() {
    var coach = qs("[data-cfp-upload-coach]");
    var warn = qs("[data-cfp-upload-warn]");
    var root = uploadRoot();
    if (coach) coach.classList.add("is-highlight");
    if (warn) warn.classList.remove("hidden");
    if (root) {
      root.classList.add("cfp-upload-highlight");
      setTimeout(function () { root.classList.remove("cfp-upload-highlight"); }, 2000);
    }
    (coach || root)?.scrollIntoView?.({ behavior: "smooth", block: "center" });
  }
  function gate(e) {
    if (!pageHasYmq() || hasUpload()) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    highlight();
    return false;
  }
  function bind() {
    atcButtons().forEach(function (btn) {
      if (!btn.__cfpBound) {
        btn.__cfpBound = true;
        btn.addEventListener("click", gate, true);
      }
    });
    qsa("form[data-type='add-to-cart-form'], product-form-component form").forEach(function (form) {
      if (!form.__cfpBound) {
        form.__cfpBound = true;
        form.addEventListener("submit", gate, true);
      }
    });
  }
  function init() {
    var coach = qs("[data-cfp-upload-coach]");
    if (coach) {
      coach.style.display = "block";
      coach.style.visibility = "visible";
      coach.style.opacity = "1";
    }
    bind();
    sync();
    var n = 0;
    var t = setInterval(function () { bind(); sync(); if (++n > 80) clearInterval(t); }, 250);
    document.addEventListener("change", function (e) { if (e.target && e.target.type === "file") setTimeout(sync, 200); });
    document.addEventListener("click", function () { setTimeout(sync, 350); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();